import {
  GraphQLID,
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType
} from 'graphql'
import { Context } from '../../shared'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../../types/generic-mutation-response'

interface DeleteAttackEventNoteMutationArgs {
  readonly input: {
    readonly organizationId: string
    readonly attackEventUuid: string
    readonly attackEventNoteUuid: string
  }
}

const deleteAttackEventNoteArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'DeleteAttackEventNoteMutationArgs',
      description:
        'Parameters that describe a delete note operation for an attack event',
      fields: () => ({
        organizationId: {
          description: 'The unique ID for the organization',
          type: new GraphQLNonNull(GraphQLID)
        },
        attackEventUuid: {
          description: 'The unique ID for the attack event',
          type: new GraphQLNonNull(GraphQLID)
        },
        attackEventNoteUuid: {
          description: 'The unique ID for the attack event note',
          type: new GraphQLNonNull(GraphQLID)
        }
      })
    })
  }
}

export const deleteAttackEventNote: GraphQLFieldConfig<
  any,
  Context,
  DeleteAttackEventNoteMutationArgs
> = {
  description: 'Delete an attack event note',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: deleteAttackEventNoteArgs,
  resolve: async (
    _source,
    args: DeleteAttackEventNoteMutationArgs,
    context: Context
  ): Promise<GenericMutationResponse> => {
    const { input } = args
    const { organizationId, attackEventUuid, attackEventNoteUuid } = input
    const { connector } = context
    await connector.executeDelete(
      `/${organizationId}/rasp/events/notes/${attackEventUuid}/${attackEventNoteUuid}`
    )

    return { _placeholder: true }
  }
}
